import "./contactUs.css";
import darkFilter from "./assets/darkFilter.svg";
import imagePart from "./assets/imagePart.svg";
import doorImage from "./assets/doorImage.svg"; // Or any side image you prefer
import { useState, useEffect } from "react";
import { contactUsPoints, patronProfilePoints } from "../../services/apis";
import { makeAuthenticatedPOSTRequest, makeAuthenticatedGETRequest } from "../../services/serverHelper";
import { useSelector } from "react-redux";
import { toast } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
import Patron_Navbar from "../Patron_Navbar";

const formDetail = [
    { placeholder: "Enter your name", type: "text", name: "name", label: "Full Name" },
    { placeholder: "Enter your email", type: "email", name: "email", label: "Email Address" },
    { placeholder: "Enter your contact number", type: "number", name: "phoneNumber", label: "Phone Number" },
    { placeholder: "Enter subject", type: "text", name: "subject", label: "Subject" },
];

function ContactUs() {
    const { accessToken } = useSelector((state) => state.auth);
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
        phoneNumber: "",
        subject: ""
    });

    const fetchPatronProfileData = async () => {
        if(!accessToken) return; 
        try {
            const response = await makeAuthenticatedGETRequest(
                patronProfilePoints.FETCH_PATRON_APPLI_API,
                accessToken
            );
            if (response.status === "success") {
                const { contactDetails, personalInfo } = response.data;
                setFormData(prev => ({
                    ...prev,
                    name: personalInfo?.authorizedPerson || "",
                    email: contactDetails?.email || "",
                    phoneNumber: contactDetails?.contactNumber || "",
                }));
            }
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        fetchPatronProfileData();
    }, []);

    const changeHandler = (event) => {
        const { name, value } = event.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const submitHandler = async (event) => {
        event.preventDefault();
        const toastId = toast.loading('Sending message...');
        try {
            const response = await makeAuthenticatedPOSTRequest(contactUsPoints.POST_QUERY_API, formData, accessToken);
            if (response.success === 'success' || response.status === 'success') {
                toast.success('Message sent successfully!', { position: "top-center" });
                setFormData({
                    name: "",
                    subject: "",
                    message: "",
                    email: "",
                    phoneNumber: ""
                });
            } else {
                toast.error(response.message || "Failed to send", { position: "top-center" });
            }
        } catch (error) {
            console.log(error);
            toast.error('Something went wrong, please try again', { position: "top-center" });
        }
        toast.dismiss(toastId);
    };

    return (
        <div className="page-wrapper">
            <Patron_Navbar />
            
            <div className="contactUs_wrapper">
                {/* --- Hero Section --- */}
                <div className="hero_section">
                    <div className="hero_image_container">
                        <img src={imagePart} alt="Contact Banner" className="hero_img" />
                        <div className="hero_overlay">
                            <h1 className="hero_title">Contact Us</h1>
                            <p className="hero_subtitle">We'd love to hear from you!</p>
                        </div>
                    </div>
                </div>

                {/* --- Main Content Section --- */}
                <div className="content_container">
                    <div className="card_wrapper">
                        
                        {/* Left Side: Image/Illustration */}
                        <div className="left_visual_side">
                            <img src={doorImage} alt="Contact Illustration" className="visual_img" />
                            {/* Optional: You can put address/phone details here overlaying the image or below it */}
                        </div>

                        {/* Right Side: Form */}
                        <div className="right_form_side">
                            <h2 className="form_heading">Get in Touch</h2>
                            <form onSubmit={submitHandler} className="actual_form">
                                {formDetail.map((detail, index) => (
                                    <div className="input_group" key={index}>
                                        <label className="input_label">{detail.label}</label>
                                        <input
                                            required
                                            name={detail.name}
                                            value={formData[detail.name]}
                                            onChange={changeHandler}
                                            type={detail.type}
                                            placeholder={detail.placeholder}
                                            className="custom_input"
                                        />
                                    </div>
                                ))}

                                <div className="input_group full_width">
                                    <label className="input_label">Message</label>
                                    <textarea
                                        required
                                        rows={5}
                                        name="message"
                                        value={formData.message}
                                        onChange={changeHandler}
                                        placeholder="Write your query here..."
                                        className="custom_textarea"
                                    />
                                </div>

                                <button type="submit" className="submit_btn">
                                    Send Message
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ContactUs;